import { render } from "./ItemDetail.vue?vue&type=template&id=11efb540&scoped=true"
import script from "./ItemDetail.vue?vue&type=script&lang=js"
export * from "./ItemDetail.vue?vue&type=script&lang=js"

import "./ItemDetail.vue?vue&type=style&index=0&id=11efb540&scoped=true&lang=css"

import exportComponent from "/Users/wadayuki/Desktop/anone/anone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11efb540"]])

export default __exports__